import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "documents-panel" }
const _hoisted_2 = { class: "filter-toggle-bar" }
const _hoisted_3 = {
  key: 0,
  class: "filter-active-badge"
}
const _hoisted_4 = { class: "filter-bar" }
const _hoisted_5 = { class: "filter-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "filter-group" }
const _hoisted_8 = { class: "filter-group" }
const _hoisted_9 = { class: "filter-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "filter-group" }
const _hoisted_12 = { class: "filter-group" }
const _hoisted_13 = {
  key: 0,
  class: "selection-bar"
}
const _hoisted_14 = { class: "sel-count" }
const _hoisted_15 = { class: "sel-actions" }
const _hoisted_16 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_17 = {
  key: 2,
  class: "doc-list"
}
const _hoisted_18 = { class: "col-check" }
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = { class: "col-title" }
const _hoisted_21 = ["data-cat"]
const _hoisted_22 = { class: "doc-title-wrap" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "doc-date-mobile" }
const _hoisted_25 = {
  key: 0,
  class: "doc-preview"
}
const _hoisted_26 = { class: "col-date" }
const _hoisted_27 = { class: "col-status" }
const _hoisted_28 = { class: "col-author" }
const _hoisted_29 = ["title"]
const _hoisted_30 = { class: "author-name" }
const _hoisted_31 = { class: "col-actions" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "lang-modal lang-modal--sm" }
const _hoisted_35 = { class: "lang-modal-header" }
const _hoisted_36 = { class: "lang-modal-sub" }
const _hoisted_37 = { class: "lang-modal-footer lang-modal-footer--gap" }
const _hoisted_38 = { class: "lang-modal" }
const _hoisted_39 = { class: "lang-modal-header" }
const _hoisted_40 = { class: "lang-modal-title" }
const _hoisted_41 = { class: "lang-grid" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "lang-flag" }
const _hoisted_44 = { class: "lang-label" }
const _hoisted_45 = { class: "lang-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonList = _resolveComponent("SkeletonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "filter-toggle-btn",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
      }, [
        _cache[18] || (_cache[18] = _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
        ], -1)),
        _cache[19] || (_cache[19] = _createTextVNode(" Filtros ", -1)),
        (_ctx.activeFilterCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.activeFilterCount), 1))
          : _createCommentVNode("", true),
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["filter-chevron", { open: _ctx.showFilters }]),
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none"
        }, [...(_cache[17] || (_cache[17] = [
          _createElementVNode("path", {
            d: "M2 4l4 4 4-4",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1)
        ]))], 2))
      ]),
      (_ctx.activeFilterCount > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "filter-clear-btn",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
          }, "Limpar filtros"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "filter-bar" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "filter-label" }, "Tipo", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "filter-select",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.typeFilter) = $event))
            }, [
              _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "Todos os tipos", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.typeFilter]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { class: "filter-label" }, "Categoria", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "filter-select",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.categoryFilter) = $event))
            }, [...(_cache[22] || (_cache[22] = [
              _createElementVNode("option", { value: "" }, "Todas", -1),
              _createElementVNode("option", { value: "relatorio" }, "Relatório", -1),
              _createElementVNode("option", { value: "dialogo" }, "Diálogo", -1),
              _createElementVNode("option", { value: "ocorrido" }, "Ocorrido", -1),
              _createElementVNode("option", { value: "permissao" }, "Permissão", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.categoryFilter]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "filter-label" }, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "filter-select",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.statusFilter) = $event))
            }, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("option", { value: "" }, "Todos", -1),
              _createElementVNode("option", { value: "enviado" }, "Enviado", -1),
              _createElementVNode("option", { value: "rascunho" }, "Rascunho", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.statusFilter]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "filter-label" }, "Autor", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "filter-select",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.authorFilter) = $event))
            }, [
              _cache[26] || (_cache[26] = _createElementVNode("option", { value: "" }, "Todos os autores", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorOptions, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_10))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.authorFilter]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "filter-label" }, "De", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "filter-input",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dateFrom) = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, _ctx.dateFrom]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "filter-label" }, "Até", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "filter-input",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateTo) = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, _ctx.dateTo]
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showFilters]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "sel-bar" }, {
      default: _withCtx(() => [
        (_ctx.selectedDocs.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.selectedDocs.length) + " selecionado" + _toDisplayString(_ctx.selectedDocs.length > 1 ? 's' : ''), 1),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  class: "export-btn export-btn--doc",
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openLang('doc')))
                }, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 15 15",
                    fill: "none"
                  }, [
                    _createElementVNode("rect", {
                      x: "2",
                      y: "1",
                      width: "11",
                      height: "13",
                      rx: "1.5",
                      stroke: "currentColor",
                      "stroke-width": "1.3"
                    }),
                    _createElementVNode("path", {
                      d: "M5 5h5M5 7.5h5M5 10h3",
                      stroke: "currentColor",
                      "stroke-width": "1.3",
                      "stroke-linecap": "round"
                    })
                  ], -1),
                  _createTextVNode(" Word ", -1)
                ]))]),
                _createElementVNode("button", {
                  class: "export-btn export-btn--pdf",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openLang('pdf')))
                }, [...(_cache[31] || (_cache[31] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 15 15",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M3 1.5h6l3 3V13a.5.5 0 01-.5.5H3A.5.5 0 012.5 13V2A.5.5 0 013 1.5z",
                      stroke: "currentColor",
                      "stroke-width": "1.3"
                    }),
                    _createElementVNode("path", {
                      d: "M9 1.5V4.5h3M5 7h1.5c.828 0 1.5.448 1.5 1s-.672 1-1.5 1H5V10",
                      stroke: "currentColor",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1),
                  _createTextVNode(" PDF ", -1)
                ]))]),
                (_ctx.accessMode === 'edit')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "export-btn export-btn--delete",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.askDelete && _ctx.askDelete(...args)))
                    }, [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("svg", {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 14 14",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          d: "M2 3.5h10M5.5 3.5V2.5h3V3.5M4.5 3.5v7.5h5V3.5",
                          stroke: "currentColor",
                          "stroke-width": "1.3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1),
                      _createTextVNode(" Apagar ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "export-btn export-btn--cancel",
                  type: "button",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedDocs = []))
                }, " Cancelar ")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_SkeletonList, {
          key: 0,
          variant: "row",
          count: 5,
          columns: [3, 40, 15, 10, 15]
        }))
      : (_ctx.filteredItems.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[33] || (_cache[33] = [
            _createStaticVNode("<svg width=\"44\" height=\"44\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.3\" data-v-190ad5a2><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-190ad5a2></path><polyline points=\"14 2 14 8 20 8\" data-v-190ad5a2></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-190ad5a2></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-190ad5a2></line><polyline points=\"10 9 9 9 8 9\" data-v-190ad5a2></polyline></svg><p class=\"empty-title\" data-v-190ad5a2>Nenhum relatório encontrado</p><p class=\"empty-sub\" data-v-190ad5a2>Tente ajustar os filtros acima.</p>", 3)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"doc-list-header\" data-v-190ad5a2><div class=\"col-check\" data-v-190ad5a2></div><div class=\"col-title\" data-v-190ad5a2>Documento</div><div class=\"col-date\" data-v-190ad5a2>Data</div><div class=\"col-status\" data-v-190ad5a2>Status</div><div class=\"col-author\" data-v-190ad5a2>Autor</div><div class=\"col-actions\" data-v-190ad5a2></div></div>", 1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(["doc-row", { selected: _ctx.selectedDocs.includes(item.id) }])
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("input", {
                    class: "doc-checkbox",
                    type: "checkbox",
                    checked: _ctx.selectedDocs.includes(item.id),
                    onChange: ($event: any) => (_ctx.toggleDoc(item.id))
                  }, null, 40, _hoisted_19)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", {
                    class: "type-badge",
                    "data-cat": item.category
                  }, _toDisplayString(_ctx.categoryLabel(item.category)), 9, _hoisted_21),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      class: "doc-title doc-title-link",
                      type: "button",
                      onClick: ($event: any) => (_ctx.$emit('view-report', item.id))
                    }, _toDisplayString(item.title), 9, _hoisted_23),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formatDateOnly(item.reportDate)), 1),
                    (_ctx.activitiesText(item))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.activitiesText(item)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.formatDateOnly(item.reportDate)), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-pill", `status-pill--${item.status}`])
                  }, _toDisplayString(item.status === 'enviado' ? 'Enviado' : 'Rascunho'), 3)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", {
                    class: "author-avatar",
                    title: item.author.name
                  }, _toDisplayString(item.author.name?.charAt(0)?.toUpperCase()), 9, _hoisted_29),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(item.author.name), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    class: "row-link",
                    type: "button",
                    onClick: ($event: any) => (_ctx.$emit('view-report', item.id))
                  }, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("svg", {
                      width: "13",
                      height: "13",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("circle", {
                        cx: "11",
                        cy: "11",
                        r: "8"
                      }),
                      _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                    ], -1),
                    _createTextVNode(" Ver ", -1)
                  ]))], 8, _hoisted_32),
                  _createElementVNode("button", {
                    class: "row-link",
                    type: "button",
                    onClick: ($event: any) => (_ctx.$emit('edit-report', item.id))
                  }, [...(_cache[35] || (_cache[35] = [
                    _createElementVNode("svg", {
                      width: "13",
                      height: "13",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                      _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                    ], -1),
                    _createTextVNode(" Editar ", -1)
                  ]))], 8, _hoisted_33)
                ])
              ], 2))
            }), 128))
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showConfirmDelete)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "lang-overlay",
            onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.showConfirmDelete = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "lang-modal-title" }, "Apagar relatórios", -1)),
                _createElementVNode("p", _hoisted_36, "Deseja apagar " + _toDisplayString(_ctx.selectedDocs.length) + " relatório" + _toDisplayString(_ctx.selectedDocs.length > 1 ? 's' : '') + " permanentemente?", 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  class: "lang-cancel",
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showConfirmDelete = false))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "delete-confirm-btn",
                  type: "button",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                }, "Apagar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showLangModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "lang-overlay",
            onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.showLangModal = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("h3", _hoisted_40, _toDisplayString(_ctx.exportTarget === 'doc' ? 'Gerar documento Word (.docx)' : 'Gerar PDF'), 1),
                _cache[38] || (_cache[38] = _createElementVNode("p", { class: "lang-modal-sub" }, "Selecione o idioma do documento gerado", -1))
              ]),
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LANGUAGES, (loc) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: loc.code,
                    class: "lang-option",
                    type: "button",
                    onClick: ($event: any) => (_ctx.selectLang(loc.code))
                  }, [
                    _createElementVNode("span", _hoisted_43, _toDisplayString(loc.flag), 1),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(loc.label), 1)
                  ], 8, _hoisted_42))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("button", {
                  class: "lang-cancel",
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showLangModal = false))
                }, "Cancelar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}